"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const functionIsAppProcessFunction = (func) => func.function === 'appProcess';
exports.default = functionIsAppProcessFunction;
